import { Reveal } from "@/components/motion";
import { SectionHeading } from "@/components/primitives";
import { Check, X } from "lucide-react";
import { COMPARISON } from "@/lib/site";
import { LOGO_URL } from "@/lib/site";

export default function ComparisonSection() {
  return (
    <section id="comparison" className="relative border-t border-border py-24 sm:py-32" data-testid="comparison-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="The difference"
          title="A dozen disconnected tools, or one connected workspace."
          subtitle="The same work, two very different realities."
        />

        <div className="mt-16 grid gap-5 sm:mt-20 lg:grid-cols-2">
          <Reveal className="rounded-3xl border border-border bg-card p-8 sm:p-10">
            <div className="flex items-center gap-3">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-destructive/10 text-destructive">
                <X className="h-5 w-5" />
              </span>
              <h3 className="font-display text-xl font-semibold tracking-tight">Disconnected tools</h3>
            </div>
            <ul className="mt-7 space-y-4">
              {COMPARISON.disconnected.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-muted-foreground">
                  <X className="mt-0.5 h-4 w-4 shrink-0 text-destructive/70" />
                  {item}
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.1} className="relative overflow-hidden rounded-3xl border border-brand-teal/40 bg-card p-8 shadow-[0_30px_70px_-30px_rgba(13,148,136,0.35)] sm:p-10">
            <div
              className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full opacity-20 blur-3xl"
              style={{ background: "var(--brand-gradient)" }}
              aria-hidden="true"
            />
            <div className="relative flex items-center gap-3">
              <img src={LOGO_URL} alt="StUpEco Workspace" className="h-8 w-auto" />
              <h3 className="font-display text-xl font-semibold tracking-tight">One workspace</h3>
            </div>
            <ul className="relative mt-7 space-y-4">
              {COMPARISON.workspace.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm">
                  <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand-teal" />
                  {item}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
